module.exports = __webpack_public_path__ + "img/ic_16_strokes.0aead3f6.svg";